import { _ as _define_property } from "@swc/helpers/_/_define_property";
import "core-js/modules/es.array.concat.js";
var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c(_vm.tag, {
        tag: "component",
        class: [
            'x-font-icon',
            _define_property({}, "x-font-icon-".concat(_vm.name), !_setup.isImageIcon)
        ],
        style: {
            color: _vm.color,
            fontSize: _setup.addUnit(_vm.size)
        }
    }, [
        _vm._t("default"),
        _setup.isImageIcon ? _c('img', {
            staticClass: "x-font-icon__image",
            attrs: {
                "src": _vm.name,
                "alt": ""
            }
        }) : _vm._e(),
        _vm.dot || _vm.badge ? _c('span', {
            class: [
                'x-font-icon__badge',
                {
                    'x-font-icon__dot': _vm.dot
                }
            ]
        }, [
            _vm._v(" " + _vm._s(_vm.badge) + " ")
        ]) : _vm._e()
    ], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };
